// extracted by mini-css-extract-plugin
export var box = "_4x-1";
export var checkboxRow = "_4x-8";
export var checked = "_4x-2";
export var descriptionSpacer = "_4x-a";
export var disabled = "_4x-3";
export var icon = "_4x-6";
export var input = "_4x-0";
export var labelSpacer = "_4x-9";
export var medium = "_4x-5";
export var small = "_4x-4";
export var text = "_4x-7";